import React, { useState } from "react";
import styles from "./PurchaseHistory.module.scss";
import { Container } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import OrderTransactionsComp from "../../../../components/AdminPortalComponents/BusinessManagement/OrderTransactions/OrderTransactions.comp";
import ComponentBackButton from "../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import PurchaseHistoryComp from "../../../../components/AdminPortalComponents/BusinessManagement/PurchaseHistory/PurchaseHistory.comp";

const orderFulfillmentData = [
    { title: "Total Orders", value: 0 },
    { title: "Total Spend", value: 0 },
    { title: "Total Points", value: 0 },
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));



const PurchaseHistory = () => {
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Purchase History</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orderFulfillmentData} />
                </div>
            </Container>
            <Container fluid className={styles.filterTableWrapper}>
                <div className="p-3 d-flex align-items-center justify-content-between">
                    <div className={`fw-semibold fs-4 ${styles.text} `}>Purchase History</div>
                </div>

                <PurchaseHistoryComp setDetails={() => setDetailView(true)} />
            </Container>

        </div>
    );
};

export default PurchaseHistory;